import React from 'react';
// commented out to fix spacing with new footer
// const StyledDiv = styled('div')`
//   margin-top: .5rem;
//   & a {
//     color: white;
//   }
// `;
const CookieConsent = () => {
    React.useEffect(() => {
        const addAriaLabels = () => {
            const links = document.querySelectorAll('#teconsent a');
            Array.from(links).forEach((link) => {
                link.setAttribute('aria-label', 'Do Not Sell or Share My Personal Information');
                link.removeAttribute('role');
            });
        };
        const updateDialogAriaLabel = () => {
            const dialog = document.querySelector('.truste_box_overlay_inner[role="dialog"]');
            if (dialog) {
                dialog.setAttribute('aria-label', 'Do Not Sell or Share My Personal Information');
            }
        };
        // Observer for #teconsent links
        const linkObserver = new MutationObserver(() => {
            const links = document.querySelectorAll('#teconsent a');
            if (links.length > 0) {
                addAriaLabels();
                linkObserver.disconnect();
            }
        });
        const container = document.getElementById('teconsent');
        if (container) {
            linkObserver.observe(container, { childList: true, subtree: true });
        }
        // Observer for dynamically loaded dialog
        const dialogObserver = new MutationObserver(() => {
            updateDialogAriaLabel();
        });
        dialogObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
        return () => {
            linkObserver.disconnect();
            dialogObserver.disconnect();
        };
    }, []);
    return (<div id="teconsent">
      <script src="https://consent.trustarc.com/asset/notice.js/v/v1.7-289" async={true} crossOrigin=""></script>
    </div>);
};
export default CookieConsent;
